module.exports = __webpack_public_path__ + "img/BannerColaboradoresyPymeMobile.c4201b35.jpg";